/* External dependencies */
import { ofType, StateObservable } from 'redux-observable';
import { from, Observable } from 'rxjs';
import { catchError, switchMap, withLatestFrom } from 'rxjs/operators';

/* Local dependencies */
import { customAuthSignIn } from '../../../../../clients/custom-auth';
import { RootState } from '../../../../../redux/store';
import { LoginAction, LoginActionTypes, loginFailed, LoginRequest, loginSucceeded } from './actions';

export function loginEpic(action$: Observable<LoginAction>, state$: StateObservable<RootState>) {
  return action$.pipe(
    ofType(LoginActionTypes.LOGIN_REQUEST),
    withLatestFrom(state$),
    switchMap(([action]: [LoginRequest, RootState]) => {
      return from(customAuthSignIn(action)).pipe(
        switchMap((result) => from([result, loginSucceeded()])),
        catchError((error) => from([loginFailed(error)])),
      );
    }),
  );
}
